import type {CoreExportFormat, WmlExportFormat} from '@wix/document-services-types'
import {getPluginsRunner} from './pluginsRunner'
import {exportWml} from './formats/wml/exportWml'
import {importWml} from './formats/wml/importWml'
import {getVersion} from './utils/version'
import type {DecoratedExportFormat, WmlConverterAPI} from './types'

const packComponentDecorated = (componentExport: CoreExportFormat): DecoratedExportFormat => {
    getPluginsRunner(componentExport).pack()
    return componentExport as DecoratedExportFormat
}

const unpackComponentDecorated = (componentCoreExport: DecoratedExportFormat): CoreExportFormat => {
    getPluginsRunner(componentCoreExport).unpack()
    return componentCoreExport
}

export * from './types'

const converter: WmlConverterAPI['converter'] = {
    pack: (coreComponentExport: CoreExportFormat): WmlExportFormat => {
        const decoratedExport: DecoratedExportFormat = packComponentDecorated(coreComponentExport)
        return exportWml(decoratedExport)
    },
    unpack: (wmlExport: WmlExportFormat): CoreExportFormat => {
        const decoratedExport: DecoratedExportFormat = importWml(wmlExport)
        return unpackComponentDecorated(decoratedExport)
    },
    getVersion
}

export {converter}
